import getDiInformations from "./actions/getInformations";
import getDiDocuments from "./actions/getDocuments";
import getDiOrders from "./actions/getOrders";

export default {
    getDiInformations,
    getDiDocuments,
    getDiOrders
};
